module.exports = __webpack_public_path__ + "img/elmosanat.e292929.png";